import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Compefferv = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66.93 82.73">
  <G fill={color}>
    <Path d="M10,49.2c-7.98,6.84-8.92,18.9-2.08,26.88,3.77,4.4,9.11,6.65,14.49,6.65,4.39,0,8.8-1.5,12.39-4.58,3.87-3.31,6.21-7.93,6.61-13.01.39-5.08-1.21-10-4.53-13.87-6.84-7.98-18.9-8.92-26.88-2.08ZM29.66,61.4l-10.64,9.11c-.56.48-1.26.72-1.95.72-.84,0-1.68-.35-2.27-1.05-1.08-1.25-.93-3.14.33-4.22l10.64-9.11c1.25-1.07,3.14-.93,4.22.33,1.08,1.25.93,3.14-.33,4.22Z"/>
    <Path d="M63.44,20.38c-2.94-4.16-7.32-6.92-12.34-7.78-5.02-.86-10.07.28-14.23,3.23-4.16,2.94-6.92,7.32-7.78,12.34-.86,5.02.29,10.07,3.23,14.23,3.71,5.25,9.61,8.05,15.59,8.05,3.81,0,7.65-1.13,10.98-3.49,8.58-6.07,10.63-17.99,4.56-26.57ZM53.64,39.55c-.53.37-1.13.55-1.73.55-.94,0-1.86-.44-2.45-1.26l-8.09-11.43c-.95-1.35-.63-3.22.72-4.17,1.35-.95,3.22-.63,4.17.72l8.09,11.43c.95,1.35.63,3.22-.72,4.17Z"/>
    <Path d="M20.32,38.13c1.04,0,1.88-.84,1.88-1.88s-.84-1.88-1.88-1.88-1.88.84-1.88,1.88.84,1.88,1.88,1.88Z"/>
    <Path d="M20.52,19.07c1.04,0,1.88-.84,1.88-1.88s-.84-1.88-1.88-1.88-1.88.84-1.88,1.88.84,1.88,1.88,1.88Z"/>
    <Path d="M50.24,3.75c1.04,0,1.88-.84,1.88-1.88s-.84-1.88-1.88-1.88-1.88.84-1.88,1.88.84,1.88,1.88,1.88Z"/>
    <Path d="M4.45,17.19c1.04,0,1.88-.84,1.88-1.88s-.84-1.88-1.88-1.88-1.88.84-1.88,1.88.84,1.88,1.88,1.88Z"/>
    <Path d="M49.42,54.95c-1.04,0-1.88.84-1.88,1.88s.84,1.88,1.88,1.88,1.88-.84,1.88-1.88-.84-1.88-1.88-1.88Z"/>
    <Path d="M54.75,69.95c-1.04,0-1.88.84-1.88,1.88s.84,1.88,1.88,1.88,1.88-.84,1.88-1.88-.84-1.88-1.88-1.88Z"/>
    <Path d="M26.01,10.21c.59.69,1.43,1.04,2.27,1.04.49,0,.97-.12,1.41-.36.57.55,1.31.84,2.06.84.69,0,1.38-.24,1.95-.72,1.18-1.01,1.36-2.73.49-3.98.83-1.1.81-2.66-.12-3.75-.93-1.09-2.48-1.33-3.68-.68-1.1-1.05-2.83-1.12-4-.11-1.18,1.01-1.36,2.73-.49,3.98-.83,1.1-.81,2.66.12,3.75Z"/>
    <Path d="M5.02,41.89l.53.47c.57.5,1.28.75,1.98.75.83,0,1.65-.34,2.24-1.01.93-1.05.98-2.58.21-3.68.73-.98.82-2.34.12-3.42-.9-1.38-2.76-1.77-4.14-.87l-.39.26-.53-.47c-1.24-1.09-3.13-.98-4.23.26-.93,1.05-.98,2.58-.21,3.68-.73.98-.82,2.34-.12,3.42.57.88,1.53,1.36,2.51,1.36.56,0,1.13-.16,1.63-.49l.39-.26Z"/>
  </G>
</Svg>
);
};

export default Compefferv;
